import React from 'react';

import Category from './Category';
import Poster from '../Poster/Poster';

const SingleCategory = () => {
  return (
    <>
      <Poster />
      <Category />
    </>
  );
};

export default SingleCategory;
